<template>
  <div
    :id="`upcoming_to_do_${instruction.id}`"
    class="py-3 px-3 relative flex flex-col bg-pure-white"
  >
    <div class="flex flex-col gap-1">
      <div class="flex items-center gap-2">
        <input
          class="cursor-pointer"
          type="checkbox"
          :checked="instruction.is_checked"
          :name="`instruction_checkbox_${instruction.id}`"
          :id="`instruction_checkbox_${instruction.id}`"
          @change="onCheckInstruction($event.target.checked)"
        />
        <div class="flex cursor-pointer truncate" @click="panelOpened = true">
          <BlTextSubtitle3
            :text="instruction.title"
            class="underline truncate"
          />
        </div>
      </div>
      <div class="pl-4 flex flex-col gap-1">
        <div class="flex">
          <div class="h-6.5 px-2 rounded-full bg-slate-200 truncate">
            <BlTextBody2
              :title="prospectName"
              :text="prospectName"
              class="truncate"
            />
          </div>
        </div>
        <div class="flex">
          <div
            class="h-6.5 px-2 rounded-full"
            :class="[isDueDateLate ? 'bg-orange-100' : 'bg-lime-100']"
          >
            <BlTextBody2
              text="Due date: "
              :class="[isDueDateLate ? 'text-orange-700' : 'text-lime-700']"
            />
            <BlTextSubtitle3
              v-if="!instruction.due_date"
              text="-"
              c
              :class="[isDueDateLate ? 'text-orange-700' : 'text-lime-700']"
            />
            <BlTextSubtitle3
              v-else
              :text="displayDate(instruction.due_date, 'DD MMM YYYY, HH:mm')"
              :class="[isDueDateLate ? 'text-orange-700' : 'text-lime-700']"
            />
          </div>
        </div>
      </div>
    </div>
    <ProspectPanel
      v-if="instruction.instructionable_id"
      :open="panelOpened"
      :id="instruction.instructionable_id"
      @close-panel="panelOpened = false"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import moment from "moment";

import ProspectPanel from "./modal/ProspectPanel.vue";

import BlTextSubtitle3 from "../BlTextSubtitle3.vue";
import BlTextBody2 from "../BlTextBody2.vue";
import BlIcon from "../BlIcon.vue";

export default {
  name: "UpcomingTodo",
  components: {
    ProspectPanel,
    BlTextSubtitle3,
    BlTextBody2,
    BlIcon
  },
  props: {
    instruction: { type: Object, required: true }
  },
  data() {
    return {
      panelOpened: false
    };
  },
  computed: {
    ...mapGetters(["currentUser"]),
    prospectName() {
      const name = this.instruction.prospect && this.instruction.prospect.name;
      return name || "Prospect name";
    },
    isDueDateLate() {
      if (!this.instruction) return false;
      if (this.instruction.instruction_type !== "todo") return false;
      if (!this.instruction.due_date) return false;
      return moment(this.instruction.due_date).isBefore(moment());
    }
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions(["updateInstruction"]),
    displayDate(date, format) {
      if (!date) return "";
      return moment(date).format(format);
    },
    onCheckInstruction(check) {
      const data = {
        id: this.instruction.id,
        instruction: { is_checked: check }
      };
      this.updateInstruction(data).then(({ success }) => {
        // if (!success) return;
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/UpcomingTodo.vue